// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sideMenu {
  width: 250px;
  background-color: #fffbf8;
  height: 100vh;
  padding-top: 20px;
}

.menuItem {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  color: #333;
  text-decoration: none;
  margin-bottom: 5px;
  transition: background-color 0.3s;
}

.menuItem:hover {
  background-color: #fff0e6;
}

.menuItem.active {
  background-color: #fff0e6;
  color: #FF6F0F;
  border-left: 3px solid #FF6F0F;
}

.menuIcon {
  margin-right: 10px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/SideMenu.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".sideMenu {\n  width: 250px;\n  background-color: #fffbf8;\n  height: 100vh;\n  padding-top: 20px;\n}\n\n.menuItem {\n  display: flex;\n  align-items: center;\n  padding: 15px 20px;\n  color: #333;\n  text-decoration: none;\n  margin-bottom: 5px;\n  transition: background-color 0.3s;\n}\n\n.menuItem:hover {\n  background-color: #fff0e6;\n}\n\n.menuItem.active {\n  background-color: #fff0e6;\n  color: #FF6F0F;\n  border-left: 3px solid #FF6F0F;\n}\n\n.menuIcon {\n  margin-right: 10px;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
